import { ResetType } from "../AppState/resetStateActions";
import { ETab } from "./app";

export const FILTER_SHOW_OD400 = [
  ETab.myAssignments,
  ETab.dashboard,
  ETab.overages,
  ETab.misdelivery,
  ETab.cleared,
];

export const FILTER_SHOW_DESTINATION = [
  ETab.myAssignments,
  ETab.dashboard,
  ETab.overages,
  ETab.onHandDelivery,
];

export const FILTER_SHOW_REPORTING = [
  ETab.myAssignments,
  ETab.dashboard,
  ETab.damages,
  ETab.shortages,
  ETab.misdelivery,
  ETab.cleared,
];

export const FILTER_SHOW_PICKUP_TERMINAL = [
  ETab.myAssignments,
  ETab.dashboard,
  ETab.cleared,
];

export const FILTER_SHOW_DRIVER = [
  ETab.myAssignments,
  ETab.dashboard,
  ETab.misdelivery,
];

export const REDUX_RESET_ACTIONS: Record<number, ResetType> = {
  [ETab.overages]: "OSD_FILTER_RESET",
  [ETab.myAssignments]: "MY_ASSIGN_FILTER_RESET",
  [ETab.damages]: "DAMAGES_FILTER_RESET",
  [ETab.onHandDelivery]: "ON_HAND_DELIVERY_FILTER_RESET",
  [ETab.dashboard]: "DASHBOARD_SEARCH_FILTER_RESET",
  [ETab.misdelivery]: "MISDELIVERY_FILTER_RESET",
  [ETab.shortages]: "SHORTAGES_FILTER_RESET",
  [ETab.cleared]: "CLEARED_FILTER_RESET",
};

export const EXCEPTION_CODE_TYPE_TO_TAB_MAPPING: Record<number, string> = {
  [ETab.overages]: "overage",
  [ETab.myAssignments]: "myAssignment",
  [ETab.cleared]: "myAssignment",
  [ETab.dashboard]: "myAssignment",
  [ETab.damages]: "damage",
  [ETab.onHandDelivery]: "onHandDelivery",
  [ETab.misdelivery]: "misDelivery",
  [ETab.shortages]: "shortage",
};

export const STATUS_TYPE_TO_TAB_MAPPING: Record<number, string> = {
  [ETab.shortages]: "shortageStatus",
  [ETab.overages]: "overageStatus",
  [ETab.damages]: "damageStatus",
  [ETab.onHandDelivery]: "onHandDeliveryStatus",
  [ETab.misdelivery]: "misdeliveryStatus",
  [ETab.myAssignments]: "myAssignmentStatus",
};


export const PRO_MASTER_SEARCH_EXCEPTION = [ETab.shortages, ETab.damages, ETab.onHandDelivery, ETab.misdelivery, ETab.cleared, ETab.myAssignments]
export const EXCEPTION_SEARCH_DESTINATION_TERMINAL_FOR = [ETab.shortages, ETab.damages, ETab.onHandDelivery, ETab.misdelivery, ETab.cleared];